import { ReactNode } from 'react'

/**
 * R111 — the one numbered step list for the whole Form Spam lane.
 *
 * Three surfaces drew this from scratch, and all three drew it differently: the
 * install page ran a 22px tint circle with a 2px rail, the link wizard's intro
 * ran a 20px tint circle with no rail at all, and the CRM recipe ran an 18px
 * OUTLINE circle with a 1px rail. Same idea, three sizes, two colours, one of
 * them missing the rail. Esteban asked for one component: the purple circle,
 * joined by a vertical line.
 *
 * The rail runs from a circle's centre to the top edge of the next circle, and
 * the circle is opaque and positioned, so it paints over both ends. That is why
 * a tall step never breaks the line: the segment is measured from the row it
 * belongs to, not from a fixed row height. The install page used to force every
 * row to `h-[22px]`, which held only one line of text; the CRM recipe's third
 * step holds a code box, and it works here without a special case.
 *
 * `!pl-0`, not `pl-0`: the browser gives an `ol` 40px of `padding-inline-start`
 * for a marker column it no longer draws, and `src/components/notes/note-list.css`
 * reads `#notes ul, ol { padding: revert !important }`. That second selector
 * lost its `#notes`, so the rule puts the 40px back on EVERY ordered list in the
 * platform, and only an important utility beats it. BUG TO REPORT, in a shared
 * file. Do not fix it here.
 *
 * The list is static. It carries no motion of its own, because every surface
 * that holds it already animates its own entrance and exit.
 */
export const StepList = ({
	items,
	className = ''
}: {
	items: ReactNode[]
	className?: string
}) => (
	<ol className={`flex flex-col gap-3 !pl-0 ${className}`}>
		{items.map((node, i) => (
			<li key={i} className="relative flex gap-2.5">
				{i < items.length - 1 && (
					<span
						aria-hidden="true"
						className="absolute bottom-[-12px] left-[9px] top-[10px] w-[2px] bg-[rgb(var(--cg-brand-tint))]"
					/>
				)}
				<span
					aria-hidden="true"
					className="relative flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[rgb(var(--cg-brand-tint))] text-[11px] font-semibold leading-[14px] text-[rgb(var(--fs-brand-on-tint))]"
				>
					{i + 1}
				</span>
				<div className="min-w-0 flex-1 text-[14px] leading-[20px] cg-text-text-secondary">
					{node}
				</div>
			</li>
		))}
	</ol>
)
